import React, { useState } from 'react';

const VolunteerForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [area, setArea] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('http://localhost:3001/api/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          email,
          phone,
          subject: 'Nuova richiesta di volontariato',
          message: `Area di interesse: ${area}\n\nMessaggio: ${message}`,
        }),
      });

      const data = await response.json();
      if (data.success) {
        alert('Grazie per il tuo interesse! Ti contatteremo presto.');
        // Reset form
        setName('');
        setEmail('');
        setPhone('');
        setArea('');
        setMessage('');
      } else {
        alert('Si è verificato un errore. Per favore riprova più tardi.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Si è verificato un errore. Per favore riprova più tardi.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-primary mb-8 text-center">Diventa Volontario</h1>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-4 text-primary">Perché diventare volontario</h3>
              
              <ul className="space-y-4">
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Contribuire concretamente a migliorare la vita dei bambini affetti da malattie rare</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Sviluppare nuove competenze e fare esperienza in ambito sociale e sanitario</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Entrare a far parte di una comunità di persone impegnate per una causa importante</span>
                </li>
                <li className="flex items-start">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Partecipare a eventi di formazione e sensibilizzazione</span>
                </li>
              </ul>
              
              <div className="mt-6 p-4 bg-primary/10 rounded-lg">
                <h4 className="font-medium text-lg mb-2 text-primary">Aree di volontariato</h4>
                <ul className="list-disc pl-5 space-y-1 text-gray-700">
                  <li>Supporto alle famiglie</li>
                  <li>Organizzazione eventi</li>
                  <li>Comunicazione e sensibilizzazione</li>
                  <li>Raccolta fondi</li>
                  <li>Supporto amministrativo</li>
                </ul>
              </div>
            </div>
            
            <div>
              <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold mb-4 text-primary">Compila il form</h3>
                
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="volunteer-name">
                    Nome e Cognome
                  </label>
                  <input
                    id="volunteer-name"
                    type="text"
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="volunteer-email">
                    Email
                  </label>
                  <input
                    id="volunteer-email"
                    type="email"
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="volunteer-phone">
                    Telefono
                  </label>
                  <input
                    id="volunteer-phone"
                    type="tel"
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>
                
                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="volunteer-area">
                    Area di Interesse
                  </label>
                  <select
                    id="volunteer-area"
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary"
                    value={area}
                    onChange={(e) => setArea(e.target.value)}
                    required
                  >
                    <option value="">Seleziona un'area</option>
                    <option value="eventi">Organizzazione Eventi</option>
                    <option value="raccolta-fondi">Raccolta Fondi</option>
                    <option value="supporto-famiglie">Supporto Famiglie</option>
                    <option value="comunicazione">Comunicazione</option>
                    <option value="amministrazione">Amministrazione</option>
                    <option value="altro">Altro</option>
                  </select>
                </div>
                
                <div className="mb-6">
                  <label className="block text-gray-700 mb-2" htmlFor="volunteer-message">
                    Messaggio
                  </label>
                  <textarea
                    id="volunteer-message"
                    className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary h-32"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Raccontaci qualcosa di te e perché vuoi unirti a noi..."
                  />
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-primary text-white py-2 px-4 rounded-lg font-semibold hover:bg-primary/90 transition duration-300"
                >
                  Invia Richiesta
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VolunteerForm;
